import { Path } from "features/Path/models";
import { useCreatePath, useDuplicatePath, useUpdatePath } from "features/Path/hooks";
import PathFormContent from "./PathFormContent";

interface PathFormProps {
  path?: Path;
  onClose?: () => void;
  onSuccess?: (path: Path) => void;
}

export function NewPathForm({ onSuccess = () => {}, onClose = () => {} }: PathFormProps) {
  const { mutate: createPath } = useCreatePath({ onClose, onSuccess });
  return (
    <PathFormContent buttonText="Create New Path" onClose={onClose} onSubmit={createPath} />
  );
}

export function DuplicatePathForm({ path, onClose = () => {} }: PathFormProps) {
  const { mutate: createPath } = useDuplicatePath({ originalPathId: path?.id, onClose });
  return (
    <PathFormContent buttonText="Duplicate Path" path={path} onClose={onClose} onSubmit={createPath} duplicate />
  );
}

export function UpdatePathForm({ path, onClose = () => {} }: PathFormProps) {
  const { mutate: updatePath } = useUpdatePath({ pathId: path?.id as string, onClose });
  return (
    <PathFormContent buttonText="Update Path" path={path} onClose={onClose} onSubmit={updatePath} />
  );
}
